var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14967 0.729964C9.0038 0.583305 8.80565 0.500588 8.5988 0.500003C8.39195 0.499418 8.19333 0.581013 8.04663 0.726844C7.96924 0.805738 7.90942 0.900116 7.87111 1.00378C7.22207 2.35801 6.50751 3.12172 5.60573 3.57261C4.59395 4.07187 3.4324 4.41901 1.56018 4.41901C1.40618 4.41974 1.25579 4.46576 1.12776 4.55135C0.999727 4.63693 0.899706 4.7583 0.840157 4.90033C0.781204 5.04292 0.765821 5.19979 0.795949 5.35113C0.826077 5.50246 0.900366 5.64148 1.00944 5.75062L3.53927 8.28046L0 13L4.71954 9.46073L7.2486 11.9898C7.32104 12.0628 7.40756 12.1204 7.5029 12.1591C7.59808 12.1988 7.69949 12.2199 7.8009 12.2199C7.90231 12.2199 8.00372 12.1988 8.09889 12.1591C8.24155 12.1005 8.36357 12.0009 8.44942 11.8728C8.53527 11.7447 8.58107 11.594 8.58099 11.4398C8.58099 9.5676 8.92735 8.40605 9.42583 7.40987C9.87594 6.50809 10.6396 5.79353 11.9947 5.14449C12.0983 5.10654 12.1925 5.04667 12.2708 4.96897C12.4166 4.82227 12.4982 4.62366 12.4977 4.4168C12.4971 4.20995 12.4144 4.0118 12.2677 3.86593L9.14967 0.729964Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.e086e4b5a014e20fa0ca47e45be4cdfb.svg";
export { ForwardRef as ReactComponent };